// LoginPage.tsx
import React, { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginForm.css";
import { Center } from "@/shared/components/center/Center";
import { Stack } from "@/shared/components/stack/Stack";
import { Logo } from "../components/logo/Logo";
import { AxiosError } from "axios";
import { login } from "../api/login";
import { storage } from "@/shared/utils";

export const LoginForm = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const formData = new FormData(e.currentTarget);
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;

    try {
      const response = await login({
        username: email,
        password: password,
      });

      // Save tokens to localStorage
      storage.setTokens({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
        expiredAt: response.expiredAt,
      });

      // Redirect to orders page
      navigate("/", { replace: true });
    } catch (err) {
      if (err instanceof Error) {
       /*  const errorMessage =
          err.response?.data?.detail ||
          err.response?.data?.message ||
          "Ошибка авторизации"; */
          const message = err instanceof Error ? err.message : "Ошибка";
        setError(message);
      } else {
        setError("Произошла неизвестная ошибка");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <Center>
        <div className="loginCard">
          <Stack gap={"32px"}>
            <Center>
              <Stack gap={"24px"} style={{ textAlign: "center" }}>
                <Logo />
                <h1 className="title">Вход в админ-панель</h1>
              </Stack>
            </Center>
            <form onSubmit={handleSubmit} className="form">
              <Stack gap={"24px"}>
                <p className="subtitle">
                  Управление чартерными рейсами <br />и бронированиями
                </p>
                <Stack gap={"16px"}>
                  <label className="field">
                    <span className="labelText">Email</span>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="input"
                      required
                    />
                  </label>

                  <label className="field">
                    <span className="labelText">Пароль</span>
                    <input
                      type="password"
                      name="password"
                      placeholder="Пароль"
                      className="input"
                      required
                    />
                  </label>
                </Stack>

                {error && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    {error}
                  </div>
                )}

                <Stack gap={"12px"}>
                  <button
                    type="submit"
                    className="submitButton"
                    disabled={isLoading}
                  >
                    {isLoading ? "Загрузка..." : "Войти"}
                  </button>

                  <button
                    onClick={() => navigate("/forgot-password")}
                    type="button"
                    className="forgotButton"
                  >
                    Забыли пароль?
                  </button>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </div>
      </Center>
    </div>
  );
};
